import React from "react";
import {css} from "emotion";
import {useRouteMatch, Link} from "react-router-dom";
import {boxStyles, colors, textSizes} from "../../styles/theme";
import PaywallBadge from "../PaywallBadge";
import getPlanFromName from "../../utils/getPlanFromName";

const PaywallLink = ({title, subtitle, planNeeded, style}) => {
  const plan = getPlanFromName(planNeeded);

  return (
    <Link to={`/checkout/${plan.id}`} className={(style && style + ' ') + container}>
      <div className="box">
        <div className="info">
          <h3>{title}</h3>
          <p>{subtitle}</p>
        </div>
      </div>
      <PaywallBadge plan={planNeeded}/>
    </Link>
  )
};

export default PaywallLink;

const container = css`
  text-decoration: none;
  padding: ${boxStyles.desktopPadding};
  color: ${colors.brandColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  
  h3 {
    opacity: .6;
  }
  
  &:first-child {
    border-top: 0;
  }
  
  &:last-child {
    border-bottom: 0;
  }
  
  .icon {
    text-align: left;
    width: 40px;
    font-size: 20px;
    padding-right: 20px;
    opacity: .5;
  }
  p {
    color: ${colors.titleColor};
    font-size: ${textSizes.subtitle};
    flex: 1;
    opacity: .6;
  }
`;
